import { render, staticRenderFns } from "./SimpleDialog.vue?vue&type=template&id=38d654f8&scoped=true"
import script from "./SimpleDialog.vue?vue&type=script&lang=js"
export * from "./SimpleDialog.vue?vue&type=script&lang=js"
import style0 from "./SimpleDialog.vue?vue&type=style&index=0&id=38d654f8&prod&scoped=true&lang=css"
import style1 from "./SimpleDialog.vue?vue&type=style&index=1&id=38d654f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_qty7iymlffgpukvncpluvycwfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d654f8",
  null
  
)

export default component.exports